import type { FallbackProps } from '@gik/core/api/BaseAPIConfig';
import { ISRRevalidateTimeout, baseFallback } from '@gik/core/api/BaseAPIConfig';
import { withTitle } from '@gik/core/hocs/withTitle';
import { catchSSRError } from '@gik/core/utils/catchSSRError';
import { measureSSRPerformance } from '@gik/core/utils/measureSSRPerformance';
import { BenefitsPage } from '@gik/marketing/pages/BenefitsPage';
import type { BenefitsPageServerProps } from '@gik/marketing/pages/BenefitsPage/BenefitsPage';
import { getPostsFeatured } from '@/api/posts/postsFeatured';
import type { PageLayoutProps } from '@/components/layout/PageLayout';
import { PageLayout } from '@/components/layout/PageLayout';
import { SWRConfig } from 'swr';

export default function BenefitsPageComp({ fallback }: FallbackProps<BenefitsPageServerProps>) {
  return withTitle(
    'Benefits',
    <SWRConfig value={{ fallback }}>
      <BenefitsPage />
    </SWRConfig>
  );
}

BenefitsPageComp.getLayout = function getLayout(page, layoutProps: PageLayoutProps) {
  return (
    <PageLayout {...layoutProps} key={layoutProps.key}>
      {page}
    </PageLayout>
  );
};

async function _getStaticProps() {
  const posts = getPostsFeatured({ slug: 'benefits-others}', perPage: 4 });

  return baseFallback(
    {
      [posts.key]: await posts.json,
    },
    undefined,
    ISRRevalidateTimeout.sitemapSlow
  );
}

export const getStaticProps = catchSSRError(measureSSRPerformance(_getStaticProps));
